// Platform configuration for India market

export const PLATFORMS = {
  AMAZON_SELLER: {
    id: 'AMAZON_SELLER',
    name: 'Amazon Seller',
    color: '#FF9900',
    gradient: 'linear-gradient(135deg, #FF9900 0%, #FFB84D 100%)',
    darkColor: '#CC7A00',
    bgColor: 'rgba(255, 153, 0, 0.1)',
    icon: '🛒'
  },
  AMAZON_RETAIL: {
    id: 'AMAZON_RETAIL',
    name: 'Amazon Vendor',
    color: '#232F3E',
    gradient: 'linear-gradient(135deg, #232F3E 0%, #37475A 100%)',
    darkColor: '#1A242F',
    bgColor: 'rgba(35, 47, 62, 0.1)',
    icon: '📦'
  },
  FLIPKART: {
    id: 'FLIPKART',
    name: 'Flipkart',
    color: '#2874F0',
    gradient: 'linear-gradient(135deg, #2874F0 0%, #5A9CF0 100%)',
    darkColor: '#1A5DC0',
    bgColor: 'rgba(40, 116, 240, 0.1)',
    icon: '🛍'
  },
  FIRSTCRY: {
    id: 'FIRSTCRY',
    name: 'FirstCry',
    color: '#E91E63',
    gradient: 'linear-gradient(135deg, #E91E63 0%, #F06292 100%)',
    darkColor: '#BA1850',
    bgColor: 'rgba(233, 30, 99, 0.1)',
    icon: '👶'
  },
  MYNTRA: {
    id: 'MYNTRA',
    name: 'Myntra',
    color: '#FF3F6C',
    gradient: 'linear-gradient(135deg, #FF3F6C 0%, #FF7096 100%)',
    darkColor: '#D63058',
    bgColor: 'rgba(255, 63, 108, 0.1)',
    icon: '👗'
  },
  NYKAA: {
    id: 'NYKAA',
    name: 'Nykaa',
    color: '#FC2779',
    gradient: 'linear-gradient(135deg, #FC2779 0%, #FD5E9E 100%)',
    darkColor: '#CA1F61',
    bgColor: 'rgba(252, 39, 121, 0.1)',
    icon: '💄'
  },
  D2C_DROGO: {
    id: 'D2C_DROGO',
    name: 'D2C Drogo',
    color: '#2E7D32',
    gradient: 'linear-gradient(135deg, #2E7D32 0%, #66BB6A 100%)',
    darkColor: '#1B5E20',
    bgColor: 'rgba(46, 125, 50, 0.1)',
    icon: '🌐'
  },
  D2C_BAYBEE: {
    id: 'D2C_BAYBEE',
    name: 'D2C Baybee',
    color: '#F57C00',
    gradient: 'linear-gradient(135deg, #F57C00 0%, #FFB74D 100%)',
    darkColor: '#E65100',
    bgColor: 'rgba(245, 124, 0, 0.1)',
    icon: '🌐'
  },
  D2C_DOMESTICA: {
    id: 'D2C_DOMESTICA',
    name: 'D2C Domestica',
    color: '#7B1FA2',
    gradient: 'linear-gradient(135deg, #7B1FA2 0%, #BA68C8 100%)',
    darkColor: '#4A148C',
    bgColor: 'rgba(123, 31, 162, 0.1)',
    icon: '🌐'
  },
  OTHERS: {
    id: 'OTHERS',
    name: 'Others',
    color: '#00BCD4',
    gradient: 'linear-gradient(135deg, #00BCD4 0%, #4DD0E1 100%)',
    darkColor: '#0097A7',
    bgColor: 'rgba(0, 188, 212, 0.1)',
    icon: '📱'
  }
};

export const PLATFORM_LIST = ['ALL', ...Object.keys(PLATFORMS)];

export const getPlatformConfig = (platformId) => {
  return PLATFORMS[platformId] || PLATFORMS.OTHERS;
};

// API Integration Configuration (Future-ready)
export const API_INTEGRATIONS = {
  AMAZON_SELLER: {
    enabled: false,
    endpoint: '/api/integrations/amazon-seller',
    authType: 'SP-API',
    requiredKeys: ['seller_id', 'marketplace_id', 'refresh_token', 'client_id', 'client_secret'],
    autoSync: false,
    syncInterval: '1h',
    lastSync: null
  },
  AMAZON_RETAIL: {
    enabled: false,
    endpoint: '/api/integrations/amazon-retail',
    authType: 'VENDOR-API',
    requiredKeys: ['vendor_id', 'marketplace_id', 'refresh_token', 'client_id', 'client_secret'],
    autoSync: false,
    syncInterval: '1h',
    lastSync: null
  },
  FLIPKART: {
    enabled: false,
    endpoint: '/api/integrations/flipkart',
    authType: 'API_KEY',
    requiredKeys: ['api_key', 'seller_id'],
    autoSync: false,
    syncInterval: '1h',
    lastSync: null
  },
  FIRSTCRY: {
    enabled: false,
    endpoint: '/api/integrations/firstcry',
    authType: 'API_KEY',
    requiredKeys: ['api_key', 'merchant_id'],
    autoSync: false,
    syncInterval: '2h',
    lastSync: null
  },
  MYNTRA: {
    enabled: false,
    endpoint: '/api/integrations/myntra',
    authType: 'API_KEY',
    requiredKeys: ['api_key', 'partner_id'],
    autoSync: false,
    syncInterval: '2h',
    lastSync: null
  },
  NYKAA: {
    enabled: false,
    endpoint: '/api/integrations/nykaa',
    authType: 'API_KEY',
    requiredKeys: ['api_key', 'seller_id'],
    autoSync: false,
    syncInterval: '2h',
    lastSync: null
  },
  D2C_DROGO: {
    enabled: false,
    endpoint: '/api/integrations/d2c-drogo',
    authType: 'API_KEY',
    requiredKeys: ['api_key', 'store_id'],
    autoSync: false,
    syncInterval: '2h',
    lastSync: null
  },
  D2C_BAYBEE: {
    enabled: false,
    endpoint: '/api/integrations/d2c-baybee',
    authType: 'API_KEY',
    requiredKeys: ['api_key', 'store_id'],
    autoSync: false,
    syncInterval: '2h',
    lastSync: null
  },
  D2C_DOMESTICA: {
    enabled: false,
    endpoint: '/api/integrations/d2c-domestica',
    authType: 'API_KEY',
    requiredKeys: ['api_key', 'store_id'],
    autoSync: false,
    syncInterval: '2h',
    lastSync: null
  }
};

/* ------------------------------------------------------------------------------------------------
 * Sales display helpers. PLATFORMS above stays the list of platforms users can pick or upload for;
 * the maps below only add names/colours for codes that can appear in reports.
 *
 *   platformLabel('AMAZON_RETAIL')  -> "Amazon Vendor"  (never show raw codes in the UI)
 *   platformColor('FLIPKART')       -> "#2563EB"        (same colour for a platform on every chart)
 *   SALES_PLATFORM_CODES            -> selectable platform codes for sales filters (no 'ALL')
 * ---------------------------------------------------------------------------------------------- */
const EXTRA_PLATFORM_NAMES = {
  AMAZON_VENDOR: 'Amazon Vendor',
  AMAZON_VENDOR_CENTRAL: 'Amazon Vendor Central',
  AMAZON_VENDOR_IMPORT: 'Amazon Vendor (Import)',
  AMAZON_INDIA_FCS: 'Amazon FCs',
  MEESHO: 'Meesho',
  BLINKIT: 'Blinkit',
  ZEPTO: 'Zepto',
  SWIGGY_INSTAMART: 'Swiggy Instamart',
  JIOMART: 'JioMart',
  AJIO: 'Ajio',
  ALL: 'All platforms',
};

// Chart colours chosen to stay distinguishable side by side (brand colours above clash: three pinks).
export const PLATFORM_CHART_COLORS = {
  AMAZON_SELLER: '#F59E0B',
  AMAZON_RETAIL: '#334155',
  AMAZON_VENDOR: '#334155',
  AMAZON_VENDOR_CENTRAL: '#334155',
  AMAZON_VENDOR_IMPORT: '#475569',
  FLIPKART: '#2563EB',
  FIRSTCRY: '#DB2777',
  MYNTRA: '#DC2626',
  NYKAA: '#A21CAF',
  D2C_DROGO: '#059669',
  D2C_BAYBEE: '#0891B2',
  D2C_DOMESTICA: '#7C3AED',
  MEESHO: '#B45309',
  OTHERS: '#94A3B8',
  // Seeded in the channel master (same colours), so charts look the same before and after it loads
  SWIGGY_INSTAMART: '#EA580C',
  BLINKIT: '#CA8A04',
  ZEPTO: '#9333EA',
  INT_SAMPLE: '#64748B',
  INT_PHOTOSHOOT: '#475569',
  INT_INFLUENCER: '#78716C',
  INT_STAFF: '#57534E',
};
const FALLBACK_COLORS = ['#0D9488', '#65A30D', '#C2410C', '#4F46E5', '#BE185D', '#0369A1'];

export const SALES_PLATFORM_CODES = Object.keys(PLATFORMS);

/* ------------------------------------------------------------------------------------------------
 * Channel master (Settings → Channels & customers, GET /api/channels). The static maps above stay the
 * fallback until it loads (and if it cannot be read), so the app never shows less than before.
 *
 *   setChannels(payload)   store { channels, groups, bins } from the API (ChannelsProvider calls it)
 *   subscribeChannels(fn)  notify on change;  getChannelsSnapshot() -> current payload or null
 *   useChannels() (hooks/useChannels.js) gives components the lists, re-rendering when they change
 * ---------------------------------------------------------------------------------------------- */
let channelState = null;
const channelListeners = new Set();
export const setChannels = payload => {
  const list = Array.isArray(payload?.channels) ? payload.channels : [];
  channelState = { channels: list, byCode: Object.fromEntries(list.map(c => [c.code, c])), groups: payload?.groups || [], bins: payload?.bins || [] };
  channelListeners.forEach(listener => listener());
};
export const subscribeChannels = listener => { channelListeners.add(listener); return () => channelListeners.delete(listener); };
export const getChannelsSnapshot = () => channelState;

export const platformLabel = code => {
  if (!code) return 'Unknown platform';
  const key = String(code).toUpperCase();
  const master = channelState?.byCode?.[key];
  if (master?.name) return master.name;
  if (PLATFORMS[key]) return PLATFORMS[key].name;
  if (EXTRA_PLATFORM_NAMES[key]) return EXTRA_PLATFORM_NAMES[key];
  return key.toLowerCase().split(/[_\s]+/).filter(Boolean).map(word => word[0].toUpperCase() + word.slice(1)).join(' ');
};

export const platformColor = code => {
  const key = String(code || '').toUpperCase();
  // The master colour wins (built-in channels are seeded with the colours below, so nothing shifts when it loads);
  // a colour changed in Settings → Channels shows on every chart.
  const master = channelState?.byCode?.[key];
  if (master?.color) return master.color;
  if (PLATFORM_CHART_COLORS[key]) return PLATFORM_CHART_COLORS[key];
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return FALLBACK_COLORS[hash % FALLBACK_COLORS.length];
};
